import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './config/firebase';
import { useStore } from './store/useStore';
import { firebaseUserToUser } from './services/firebase/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import DashboardPage from './pages/Dashboard';
import NewAnalysis from './pages/NewAnalysis';
import Settings from './pages/Settings';
import ChatPage from './pages/Chat';
import Diagnostics from './pages/Diagnostics';
import PrivateRoute from './components/PrivateRoute';
import LoadingScreen from './components/LoadingScreen';

export default function App() {
  const { setUser, isInitializing, setIsInitializing } = useStore();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        const user = firebaseUserToUser(firebaseUser);
        setUser(user);
      } else {
        setUser(null);
      }
      setIsInitializing(false);
    });

    return () => unsubscribe();
  }, [setUser, setIsInitializing]);

  if (isInitializing) {
    return <LoadingScreen />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Layout />}>
          <Route path="/" element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          } />
          <Route path="/new" element={
            <PrivateRoute>
              <NewAnalysis />
            </PrivateRoute>
          } />
          <Route path="/settings" element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          } />
          <Route path="/chat" element={
            <PrivateRoute>
              <ChatPage />
            </PrivateRoute>
          } />
          <Route path="/diagnostics" element={
            <PrivateRoute>
              <Diagnostics />
            </PrivateRoute>
          } />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
